import * as tslib_1 from "tslib";
import * as React from 'react';
import { createPortal } from 'react-dom';
import cn from 'astro-classname';
import '../portal/index.css';
var Portal = (function (_super) {
    tslib_1.__extends(Portal, _super);
    function Portal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Portal.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, center = _a.center, selector = _a.selector, visiable = _a.visiable, others = tslib_1.__rest(_a, ["className", "children", "center", "selector", "visiable"]);
        var classes = cn('zhui-portal', className, {
            'zhui-portal-center': center,
            'zhui-portal-hide': !visiable
        });
        var selectorContainer = document.querySelector(selector);
        if (!selectorContainer)
            return null;
        return createPortal(React.createElement("div", tslib_1.__assign({ className: classes }, others), children), selectorContainer);
    };
    Portal.defaultProps = {
        className: '',
        selector: 'body',
        center: false,
        visiable: true
    };
    return Portal;
}(React.Component));
export default Portal;
